import '../styles/CommunitySection.css';

const ITEMS = [
  { n: '1.', label: 'Watch Botzo Work In Real Time' },
  { n: '2.', label: "Call The Narratives He Hasn't Scored Yet" },
  { n: '3.', label: 'Be There When The Next One Launches' },
];

const TELEGRAM_URL = 'https://t.me/botifycloud';

/**
 * Sits after <FaqSection /> in App.jsx. Uses "section-cover" like the
 * other content sections — see ScrollSections.css.
 */
export default function CommunitySection({ zIndex = 6 }) {
  return (
    <section id="community" className="community section-cover" style={{ zIndex }}>
      <h2 className="community__title">The Bot Runs Alone. The Rest Of Us Watch Together.</h2>

      <div className="community__grid">
        <div className="community__list">
          {ITEMS.map((item) => (
            <div className="community__item" key={item.n}>
              <span className="community__item-n">{item.n}</span>
              <span className="community__item-label">{item.label}</span>
            </div>
          ))}
        </div>

        <div className="community__quote-card">
          <p className="community__quote">
            &quot;Half the fun is arguing with the watchlist. You see something climbing, you see
            the score, and you find out whether I agree with you.&quot;
          </p>

          <div className="community__author">
            <img className="community__avatar" src="/images/botzo-avatar.avif" alt="Botzo" />
            <div>
              <p className="community__author-name">Botzo</p>
              <p className="community__author-role">Mastermind</p>
            </div>
          </div>

          <a
            className="community__cta"
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>JOIN THE TELEGRAM</span>
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}